export const data = {
  whoWeAre: 'We are iDaily Academy, an E-Learning platform offering a new way to learn. Our aim is to transform the traditional ' +
    'learning patterns whilst making education affordable'
}